import { render, staticRenderFns } from "./ReplaceUser.vue?vue&type=template&id=8dba2e1e&"
import script from "./ReplaceUser.vue?vue&type=script&lang=js&"
export * from "./ReplaceUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports